import React from "react";

/**
 * Global trading mode toggle — "snipe" (default, wider zones, higher RR)
 * vs "scalp" (tight zones, faster turnover, 7-day history retention).
 *
 * Persisted in localStorage so it survives reloads.
 */
const STORAGE_KEY = "aureus.mode";
export const MODES = { SNIPE: "snipe", SCALP: "scalp" };

export const ModeContext = React.createContext({
  mode: MODES.SNIPE,
  setMode: () => {},
});

export function ModeProvider({ children }) {
  const initial = (typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY)) || MODES.SNIPE;
  const [mode, setModeState] = React.useState(initial === MODES.SCALP ? MODES.SCALP : MODES.SNIPE);

  const setMode = React.useCallback((next) => {
    setModeState(next);
    try { window.localStorage.setItem(STORAGE_KEY, next); } catch (_) { /* ignore quota */ }
  }, []);

  const value = React.useMemo(() => ({ mode, setMode }), [mode, setMode]);
  return <ModeContext.Provider value={value}>{children}</ModeContext.Provider>;
}
